export const getConfiguration = async () => {
  let json = null;

  try {
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/configuration`);
    json = await response.json();
  } catch (err) {
    //    // console.log("Exception: " + err);
  }

  return json;
};
